import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import app from 'flarum/forum/app';

import PointsRanking from './components/PointsRanking';

export default function () {
  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    items.add('pointsRanking', <PointsRanking />, -1);
  });
}
